import {Tag} from 'letrus-ui';
import {useState} from 'react';
import styles from './MessageFilter.module.scss';

export type MessageFilters = 'all' | 'new' | 'seen';

export interface MessageFilterProps {
  onFilterChange: (filter?: boolean) => void;
}

function MessageFilter({onFilterChange}: MessageFilterProps) {
  const [activeFilter, setActiveFilter] = useState<MessageFilters>('all');

  const handleFilterClick = (filter: MessageFilters) => {
    setActiveFilter(filter);
    onFilterChange(filter === 'all' ? undefined : filter === 'seen');
  };

  return (
    <ul className={styles.filterList}>
      <li className={styles.filterOption} data-active={activeFilter === 'all'}>
        <Tag
          text="Todas"
          variant="operational"
          onClickTag={() => handleFilterClick('all')}
        />
      </li>

      <li className={styles.filterOption} data-active={activeFilter === 'new'}>
        <Tag
          text="Novas mensagens"
          variant="operational"
          onClickTag={() => handleFilterClick('new')}
        />
      </li>

      <li className={styles.filterOption} data-active={activeFilter === 'seen'}>
        <Tag
          text="lidas"
          variant="operational"
          onClickTag={() => handleFilterClick('seen')}
        />
      </li>
    </ul>
  );
}

export default MessageFilter;
